// extracted by mini-css-extract-plugin
export default {"heading":"Login_heading__7bnGX","form":"Login_form__wjEbu"};